import {FaFacebook, FaInstagram, FaXTwitter} from "react-icons/fa6";
import React from "react";

export default function RenderPlatformIcon({platform, size = 24}:{
    platform: 'instagram' | 'facebook' | "twitter",
    size?: number
}){
    switch (platform) {
        case 'instagram':
            return <FaInstagram size={size}/>
        case 'facebook':
            return <FaFacebook size={size}/>
        case 'twitter':
            return <FaXTwitter size={size}/>
        default:
            return null;
    }
}
